<template>
  <div>
    <CRow>
      <CCol>
        <span class="font-weight-bold"> {{ onCheck(fields.evaluationPlan) }} </span>
      </CCol>
    </CRow>

    <CRow>
      <CCol>
        <div class="p-2" v-html=this.onCheck(this.fields.evaluation)></div>
      </CCol>
    </CRow>

    <CRow class="mt-2">
      <CCol>
        <table-consistency
          small
          :items="data.evaluation"
          :fields="onCheck(table.evaluation)"
        />
      </CCol>
    </CRow>


    <CRow>
      <CCol>
        <span class="font-weight-bold"> {{ onCheck(fields.remark) }} </span>
      </CCol>
    </CRow>


  </div>
</template>

<script>

import {mapGetters} from 'vuex'

import Vue from 'vue'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import TableConsistency from "@/project/containers/sub/TableConsistency";
import TableLesssonPlans from "@/project/containers/sub/TableLessonPlans";

Vue.use(VueQuillEditor)

export default {
  name: 'EvaluationPlan',
  components: {TableLesssonPlans, TableConsistency},
  props: {
    disable: {
      type: Boolean,
      default: false
    },
    tqf: {
      type: Number,
      default: 0
    },
  },
  data: function () {
    return {
      table: {

        evaluation : [{
          key: "th",
          value: [
            {key: 'learning', label: 'ผลการเรียนรู้',_style:'text-align: center'},
            {key: 'method', label: 'วิธี/รูปแบบ การประเมิน',_style:'text-align: center'},
            {key: 'assessor', label: 'ผู้ประเมิน',_style:'text-align: center'},
            {key: 'week', label: 'สัปดาห์ที่ประเมิน',_style:'text-align: center'},
            {key: 'proportion', label: 'สัดส่วนของการประเมิน',_style:'text-align: center'},
            {key: '#', label: '#',_style:'text-align: center'},
          ]
        }, {
          key: "en",
          value: [
            {key: 'learning', label: 'Domain of Learning',_style:'text-align: center'},
            {key: 'method', label: 'Assessment Method',_style:'text-align: center'},
            {key: 'assessor', label: 'Assessor',_style:'text-align: center'},
            {key: 'week', label: 'Assessment Week',_style:'text-align: center'},
            {key: 'proportion', label: 'Assessment Proportion',_style:'text-align: center'},
            {key: '#', label: '#',_style:'text-align: center'},
          ]
        }]



      },
      fields : {
        evaluationPlan: [
          {
            key: "th",
            value: "แผนการประเมินการเรียนรู้"
          },
          {
            key: "en",
            value: "Evaluation Plan"
          }
        ],
        evaluation: [
          {
            key: "th",
            value: '<p class="ql-align-justify"><span style="color: rgb(0, 0, 0);"> &nbsp; &nbsp; </span><span style="background-color: transparent; color: rgb(0, 0, 0);">ระบุวิธีการประเมินผลการเรียนรู้หัวข้อย่อยแต่ละหัวข้อตามที่ปรากฏในแผนที่แสดงการกระจายความรับผิดชอบของรายวิชา (Curriculum Mapping) ตามที่กำหนดในรายละเอียดของหลักสูตร สัปดาห์ที่ประเมิน และสัดส่วนของการประเมิน</span><span style="color: rgb(0, 0, 0);"> &nbsp; &nbsp; </span><span style="background-color: transparent; color: rgb(0, 0, 0);">ให้สอดคล้องกัน</span></p>'
          },
          {
            key: "en",
            value: '<p class="ql-align-justify"><span style="color: rgb(0, 0, 0);"> &nbsp; &nbsp; </span><span style="background-color: transparent; color: rgb(0, 0, 0);">Specify the details of assessment method and assessment proportion of each topic as stated in the curriculum mapping</span></p>'
          }
        ],

        remark: [
          {
            key: "th",
            value: "หมายเหตุ: เป็นข้อมูลส่วนหนึ่งประกอบการทวนสอบผลการประเมินการเรียนรู้ทุกรายวิชาที่เปิดสอนในแต่ละปีการศึกษา"
          },
          {
            key: "en",
            value: "Remark: This information will be a part of verification of learning outcomes of all courses of each semester."
          }
        ],

      },
      data: {
        evaluation : [],

      }

    }
  },
  mounted() {

  },

  created() {
    // this.content = this.onCheck(this.values.fields)
  },

  beforeDestroy() {

  },

  methods: {

    onCheck(key) {
      for (var i = 0; i < key.length; i++) {
        if (key[i].key == this.lang) {
          return key[i].value;
        }
      }
    },

    chaneSuggestion(html, text, quill) {
      // this.onCheckIndex(this.data.reason,html.html)
    },

    chaneLecturer(html, text, quill) {
      // this.onCheckIndex(this.data.reason,html.html)
    },

    addVerlification(){

    }

  },



  computed: {
    ...mapGetters({
      lang: "setting/objLang",
    })
  },

  watch: {
    // Watch content change

  }
}
</script>
